import {
  swalWithConfirmAndCancelButtons,
  swalWithConfirmButton,
} from "components/custom/swal"
import SyncfusionGrid from "components/custom/Syncfusion/SyncfusionGrid"
import React, { useRef, useState } from "react"
import { toast } from "react-toastify"
import {
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from "reactstrap"
import api from "services/api.service"
import { userService } from "services/user.service"
import { exportTableToExcel } from "utils/exportToExcel"

const IdeasGrid = ({ ideas, props, reload }) => {
  var gridRef = useRef(null)
  const currentUser = userService.getLoggedInUser()
  const [showActionsDropdown, setShowActionsDropdown] = useState(false)
  const [showBatchDropdown, setShowBatchDropdown] = useState(false)

  const handleNamePress = (e, alternative) => {
    e && e.preventDefault()

    props.history.push(
      `/editProject/${alternative.scenarioID}/${alternative.alternativeID}`
    )
  }

  const exportTable = () => {
    let colsToExport = columns.filter(x => x.field !== undefined)
    exportTableToExcel(
      ideas,
      colsToExport.map(c => {
        return { property: c.field, heading: c.title }
      }),
      "Ideas.csv"
    )
  }

  const showSelectionAlert = () => {
    swalWithConfirmButton.fire({
      title: `You must select at least one idea to run this.`,
      icon: "warning",
      showCancelButton: false,
      confirmButtonText: "Ok",
    })
  }

  const deleteIdeas = () => {
    let selected = gridRef.current.getSelectedRecords()
    if (selected.length > 0) {
      swalWithConfirmAndCancelButtons
        .fire({
          title: `Are you sure you want to delete the selected ideas?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
          reverseButtons: true,
        })
        .then(async result => {
          if (result.isConfirmed) {
            let tasks = selected.map(x => async () => {
              return await api.deleteAlternative(x.alternativeID)
            })
            await Promise.all(tasks.map(t => t()))
            toast.success("Ideas deleted successfully.")
            reload()
          }
        })
    } else {
      showSelectionAlert()
    }
  }

  const promoteIdeas = async () => {
    let selected = gridRef.current.getSelectedRecords()
    if (selected.length == 0) {
      swalWithConfirmButton.fire({
        title: `You cannot run this option without Ideas selected`,
        icon: "warning",
        showCancelButton: false,
        confirmButtonText: "Ok",
      })
    } else {
      let tasks = selected.map(x => async () => {
        return await api.updateAlternative(currentUser.userID, {
          ...x,
          ideaOnly: false,
          limitAccess: false,
        })
      })
      await Promise.all(tasks.map(t => t()))
      toast.success("Ideas promoted successfully")
      reload()
    }
  }

  const columns = [
    {
      type: "checkbox",
      width: 50,
    },
    {
      headerText: "ID",
      field: "alternativeNum",
      width: 80,
      template: data => {
        return "Idea"
      },
    },
    {
      headerText: "Decision",
      field: "scenarioName",
      width: 300,
      clipMode: "EllipsisWithTooltip",
    },
    {
      headerText: "Project",
      field: "alternativeName",
      width: 400,
      template: data => (
        <a href="#" onClick={e => handleNamePress(e, data)}>
          {data.alternativeName}
        </a>
      ),
    },

    {
      headerText: "Sponsoring Unit",
      field: "sponsoringUnit",
      width: 240,
    },
    {
      headerText: "Lead Business Representative",
      field: "leadUser",
      width: 240,
    },
    {
      headerText: "Business Relationship Manager",
      field: "brmUser",
      width: 240,
    },
    {
      headerText: "Planning Category",
      field: "projectCategory",
      width: 240,
    },

    {
      headerText: "Program",
      field: "program",
      filter: {
        type: "Excel",
        itemTemplate: data => {
          return (
            <div
              style={{ lineHeight: "20px" }}
              dangerouslySetInnerHTML={{
                __html: data.program,
              }}
            ></div>
          )
        },
      },
      template: data => (
        <div
          style={{ lineHeight: "20px" }}
          dangerouslySetInnerHTML={{
            __html: data.program,
          }}
        ></div>
      ),
    },
    {
      headerText: "Business Case Status",
      field: "bcState",
      filter: {
        type: "Excel",
        itemTemplate: data => {
          return (
            <div
              style={{ lineHeight: "20px" }}
              dangerouslySetInnerHTML={{
                __html: data.bcState,
              }}
            ></div>
          )
        },
      },
      template: data => (
        <div
          style={{ lineHeight: "20px" }}
          dangerouslySetInnerHTML={{
            __html: data.bcState,
          }}
        ></div>
      ),
    },
    {
      headerText: "Roadmaps",
      field: "roadmapList",
      width: 200,
      clipMode: "EllipsisWithTooltip",
    },
  ]

  return (
    <div>
      <Row className="mb-3">
        <Col
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div>
            <Dropdown
              direction="start"
              className="save-user"
              isOpen={showBatchDropdown}
              toggle={() => setShowBatchDropdown(!showBatchDropdown)}
            >
              <DropdownToggle tag="button" className="btn btn-outline-primary">
                Batch Updates <i className="mdi mdi-chevron-down" />
              </DropdownToggle>
              <DropdownMenu style={{ maxHeight: "500px", overflowX: "auto" }}>
                <DropdownItem
                  onClick={() => {
                    deleteIdeas()
                  }}
                >
                  Delete Idea(s)
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Dropdown
              direction="start"
              className="save-user"
              isOpen={showActionsDropdown}
              toggle={() => setShowActionsDropdown(!showActionsDropdown)}
            >
              <DropdownToggle tag="button" className="btn btn-outline-primary">
                Actions <i className="mdi mdi-chevron-down" />
              </DropdownToggle>
              <DropdownMenu style={{ maxHeight: "500px", overflowX: "auto" }}>
                <DropdownItem
                  onClick={() => {
                    promoteIdeas()
                  }}
                >
                  <i className="fas fa-share"></i> Promote Idea(s)
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    exportTable()
                  }}
                >
                  <i className="fas fa-table"></i> Export Table
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <SyncfusionGrid
            gridRef={gridRef}
            columns={columns}
            data={ideas}
            selectionSettings={{
              type: "Multiple",
              mode: "Row",
              checkboxOnly: true,
            }}
          />
        </Col>
      </Row>
    </div>
  )
}

export default IdeasGrid
